import { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import { COMPANY } from "@/lib/company";

const DEFAULT_AR = 362 / 98;
let _branding = null;
let _pending = null;
let _logoData = null;
const listeners = new Set();

export function fetchBranding(force = false) {
  if (_branding && !force) return Promise.resolve(_branding);
  if (!_pending) {
    _pending = api.get("/settings/branding").then((r) => r.data || {}).catch(() => ({})).then((b) => {
      _branding = b; _logoData = null; _pending = null;
      listeners.forEach((fn) => fn(b));
      return b;
    });
  }
  return _pending;
}

export function brandingNow() { return _branding || {}; }

export function logoSrc() {
  const b = brandingNow();
  return b.logo_url ? fileUrl(b.logo_url) : `${window.location.origin}${COMPANY.logo}`;
}

export function logoAspect() {
  const b = brandingNow();
  return b.logo_width && b.logo_height ? b.logo_width / b.logo_height : DEFAULT_AR;
}

export async function loadCompanyLogo() {
  await fetchBranding();
  if (_logoData !== null) return _logoData;
  try {
    const res = await fetch(logoSrc());
    const blob = await res.blob();
    _logoData = await new Promise((resolve) => { const rd = new FileReader(); rd.onloadend = () => resolve(rd.result); rd.readAsDataURL(blob); });
  } catch { _logoData = ""; }
  return _logoData;
}

export function useBranding() {
  const [b, setB] = useState(brandingNow());
  useEffect(() => { fetchBranding().then(setB); listeners.add(setB); return () => listeners.delete(setB); }, []);
  return b;
}
